import { Tag, TagProps } from '@loadsmart/loadsmart-ui'
import { CircularProgress, Badge } from '@mui/material'
import { Box } from '@mui/material'
import { MouseEvent } from 'react'

export enum ValidationStatus {
  PENDING = 'Pending',
  RUNNING = 'Running',
  FAILED = 'Failed',
  SUCCESS = 'Success',
}

export interface ValidationStatusTagProps extends Omit<TagProps, 'variant'> {
  status: ValidationStatus
  onClick?: (e: MouseEvent) => void
  showLoadingSpinner?: boolean
  showFailureBadge?: boolean
}

const STATUS_VARIANT_MAPPING: Record<ValidationStatus, TagProps['variant']> = {
  [ValidationStatus.PENDING]: 'default',
  [ValidationStatus.RUNNING]: 'warning',
  [ValidationStatus.FAILED]: 'danger',
  [ValidationStatus.SUCCESS]: 'accent',
}

export default function ValidationStatusTag({
  status,
  onClick,
  showLoadingSpinner = true,
  showFailureBadge = false,
  size = 'default',
  ...tagProps
}: ValidationStatusTagProps) {
  const variant = STATUS_VARIANT_MAPPING[status]
  const isClickable = !!onClick
  const shouldShowBadge = status === ValidationStatus.FAILED && showFailureBadge && isClickable

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: isClickable ? 'pointer' : 'default',
      }}
    >
      <Badge
        variant="dot"
        color="error"
        invisible={!shouldShowBadge}
        sx={{
          '& .MuiBadge-dot': {
            backgroundColor: 'error.main',
          },
        }}
      >
        <Tag variant={variant} size={size} onClick={onClick} {...tagProps}>
          {status}
        </Tag>
      </Badge>
      {status === ValidationStatus.RUNNING && showLoadingSpinner && <CircularProgress size={16} />}
    </Box>
  )
}
